import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("evk-cookie-consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("evk-cookie-consent", "accepted");
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem("evk-cookie-consent", "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 md:max-w-md z-50">
      <div className="glass-card p-6 space-y-4">
        <p className="text-sm text-foreground font-medium">
          Este site utiliza cookies 🍪
        </p>
        <p className="text-xs text-muted-foreground leading-relaxed">
          Utilizamos cookies para melhorar a sua experiência. Ao continuar a navegar, concorda com a nossa{" "}
          <Link to="/privacidade" className="text-accent hover:underline">
            Política de Privacidade
          </Link>.
        </p>
        <div className="flex gap-3">
          <button onClick={accept} className="glass-btn px-5 py-2.5 text-xs font-medium flex-1">
            Aceitar
          </button>
          <button
            onClick={reject}
            className="px-5 py-2.5 text-xs font-medium rounded-full border border-border text-muted-foreground hover:text-foreground transition-colors flex-1"
          >
            Recusar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
